export const shopifyCartAPIAdd = async (items) => {
    return await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
    }).then(async (response) => await response.json());
};
